import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/PageHeader";
import { Search, Loader2, Users } from "lucide-react";

export default function ClientSearches() {
  const navigate = useNavigate();
  const [searches, setSearches] = useState(null);
  useEffect(() => { api.get("/client/searches").then(({ data }) => setSearches(data)); }, []);
  return (
    <div>
      <PageHeader overline="Your mandates" title="My Searches" />
      <div className="p-8">
        {!searches && <div className="flex justify-center py-24"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>}
        {searches && searches.length === 0 && <Empty icon={Search} title="No active searches" hint="Your recruiter will set up searches for your organization. They'll appear here." />}
        {searches && searches.length > 0 && (
          <div className="space-y-px bg-black/10 border border-black/10">
            {searches.map((s) => (
              <button key={s.id} onClick={() => navigate(`/client/searches/${s.id}`)} data-testid={`csearch-${s.id}`}
                className="w-full bg-white p-5 flex items-center justify-between hover:bg-[#F1F1F3] transition-colors text-left">
                <div>
                  <p className="font-medium">{s.title}</p>
                  <p className="overline text-[0.55rem] mt-1">{s.role_type} · {s.status}</p>
                </div>
                <span className="flex items-center gap-1.5 text-sm text-muted-foreground"><Users className="h-4 w-4" /> {s.shared_count} shared</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
